import { drawArrow } from './drawingUtils/drawingUtils';

export const renderArea = (ctx, area, cornerCircleDiameter) => {
  if (!area.points) return;
  ctx.beginPath();
  ctx.moveTo(area.points[0].x, area.points[0].y);
  area.points.forEach((point) => ctx.lineTo(point.x, point.y));
  ctx.closePath();
  ctx.fillStyle = area.fillColor;
  ctx.strokeStyle = area.lineColor;
  ctx.lineWidth = area.lineWidth;
  ctx.fill();
  ctx.stroke();

  area.points.forEach((point) => {
    ctx.beginPath();
    ctx.arc(point.x, point.y, cornerCircleDiameter, 0, 2 * Math.PI);
    ctx.fillStyle = '#ff0000';
    ctx.fill();
  });
};

export const renderText = (ctx, text) => {
  ctx.font = `${text.fontSize || 16}px ${text.fontFamily || 'Arial'}`;
  ctx.fillStyle = text.textColor || '#000';
  ctx.fillText(text.text, text.x, text.y);
};

export const renderLine = (ctx, line, cornerCircleDiameter) => {
  if (line.points) {
    if (line.points.length > 1) {
      ctx.beginPath();
      ctx.moveTo(line.points[0].x, line.points[0].y);
      for (let i = 1; i < line.points.length; i++) {
        ctx.lineTo(line.points[i].x, line.points[i].y);
      }
      ctx.lineWidth = line.lineWidth;
      ctx.strokeStyle = line.lineColor;
      ctx.stroke();
    }

    line.points.forEach((point) => {
      ctx.beginPath();
      ctx.arc(point.x, point.y, cornerCircleDiameter, 0, 2 * Math.PI);
      ctx.fillStyle = '#ff0000';
      ctx.fill();
    });
  } else {
    ctx.beginPath();
    ctx.moveTo(line.startX, line.startY);
    ctx.lineTo(line.endX, line.endY);
    ctx.lineWidth = line.lineWidth;
    ctx.strokeStyle = line.lineColor;
    ctx.stroke();

    ctx.beginPath();
    ctx.arc(line.startX, line.startY, cornerCircleDiameter, 0, 2 * Math.PI);
    ctx.fillStyle = '#ff0000';
    ctx.fill();

    ctx.beginPath();
    ctx.arc(line.endX, line.endY, cornerCircleDiameter, 0, 2 * Math.PI);
    ctx.fillStyle = '#ff0000';
    ctx.fill();
  }
};

export const renderArrow = (ctx, arrow, cornerCircleDiameter) => {
  drawArrow(
    ctx,
    arrow.startX,
    arrow.startY,
    arrow.endX,
    arrow.endY,
    arrow.lineWidth,
    arrow.lineColor
  );

  const smallerRadius = cornerCircleDiameter * 0.6;

  ctx.beginPath();
  ctx.arc(arrow.startX, arrow.startY, smallerRadius, 0, 2 * Math.PI);
  ctx.fillStyle = '#ff0000';
  ctx.fill();

  ctx.beginPath();
  ctx.arc(arrow.endX, arrow.endY, smallerRadius, 0, 2 * Math.PI);
  ctx.fillStyle = '#ff0000';
  ctx.fill();
};

export const renderPenStroke = (ctx, stroke) => {
  if (stroke.points.length > 1) {
    ctx.beginPath();
    ctx.moveTo(stroke.points[0].x, stroke.points[0].y);
    stroke.points.forEach((point) => ctx.lineTo(point.x, point.y));
    ctx.lineWidth = stroke.lineWidth;
    ctx.lineCap = stroke.lineCap;
    ctx.strokeStyle = stroke.lineColor;
    ctx.stroke();
  }
};

export const renderSquare = (ctx, square, cornerCircleDiameter) => {
  ctx.beginPath();
  ctx.rect(square.x, square.y, square.width, square.height);
  ctx.fillStyle = square.fillColor;
  ctx.strokeStyle = square.lineColor;
  ctx.lineWidth = square.lineWidth;
  ctx.fill();
  ctx.stroke();

  const corners = [
    [square.x, square.y],
    [square.x + square.width, square.y],
    [square.x, square.y + square.height],
    [square.x + square.width, square.y + square.height],
  ];

  corners.forEach(([x, y]) => {
    ctx.beginPath();
    ctx.arc(x, y, cornerCircleDiameter, 0, 2 * Math.PI);
    ctx.fillStyle = '#ff0000';
    ctx.fill();
  });
};

export const renderCircle = (ctx, circle, cornerCircleDiameter) => {
  ctx.beginPath();
  ctx.ellipse(
    circle.centerX,
    circle.centerY,
    circle.radiusX,
    circle.radiusY,
    0,
    0,
    2 * Math.PI
  );
  ctx.fillStyle = circle.fillColor;
  ctx.strokeStyle = circle.lineColor;
  ctx.lineWidth = circle.lineWidth;
  ctx.fill();
  ctx.stroke();

  const controlPoints = [
    [circle.centerX, circle.centerY - circle.radiusY],
    [circle.centerX + circle.radiusX, circle.centerY],
    [circle.centerX, circle.centerY + circle.radiusY],
    [circle.centerX - circle.radiusX, circle.centerY],
  ];

  controlPoints.forEach(([x, y]) => {
    ctx.beginPath();
    ctx.arc(x, y, cornerCircleDiameter, 0, 2 * Math.PI);
    ctx.fillStyle = '#ff0000';
    ctx.fill();
  });
};

export const renderLegend = (ctx, legend, cornerCircleDiameter) => {
  ctx.fillStyle = legend.backgroundColor;
  ctx.fillRect(legend.x, legend.y, legend.width, legend.height);

  ctx.strokeStyle = legend.borderColor;
  ctx.lineWidth = legend.borderWidth;
  ctx.strokeRect(legend.x, legend.y, legend.width, legend.height);

  const corners = [
    [legend.x, legend.y],
    [legend.x + legend.width, legend.y],
    [legend.x, legend.y + legend.height],
    [legend.x + legend.width, legend.y + legend.height],
  ];

  corners.forEach(([x, y]) => {
    ctx.beginPath();
    ctx.arc(x, y, cornerCircleDiameter, 0, 2 * Math.PI);
    ctx.fillStyle = '#ff0000';
    ctx.fill();
  });

  const legendTop = Math.min(legend.y, legend.y + legend.height);
  const legendLeft = Math.min(legend.x, legend.x + legend.width);
  const legendHeight = Math.abs(legend.height);
  const itemHeight = 30;
  const maxItemsPerColumn = Math.floor((legendHeight - 20) / itemHeight);

  legend.items.forEach((item, index) => {
    const column = Math.floor(index / maxItemsPerColumn);
    const rowInColumn = index % maxItemsPerColumn;
    const itemY = legendTop + 20 + rowInColumn * itemHeight;
    const iconX = legendLeft + 10 + column * 120;
    const iconY = itemY;

    ctx.strokeStyle = item.color;
    ctx.fillStyle = item.color;
    ctx.lineWidth = 2;
    if (item.tool === 'area') {
      ctx.fillRect(iconX, iconY, 20, 20);
    } else if (item.tool === 'line') {
      ctx.beginPath();
      ctx.moveTo(iconX, iconY + 10);
      ctx.lineTo(iconX + 20, iconY + 10);
      ctx.stroke();
    } else if (item.tool === 'arrow') {
      drawArrow(ctx, iconX, iconY + 10, iconX + 20, iconY + 10, 2, item.color);
    } else if (item.tool === 'square') {
      ctx.strokeRect(iconX, iconY, 20, 20);
    } else if (item.tool === 'circle') {
      ctx.beginPath();
      ctx.ellipse(iconX + 10, iconY + 10, 10, 10, 0, 0, 2 * Math.PI);
      ctx.stroke();
    } else if (item.tool === 'text') {
      ctx.fillStyle = item.color;
      ctx.font = 'bold 16px Arial';
      ctx.fillText('Aa', iconX + 2, iconY + 16);
    } else if (item.tool === 'pen') {
      ctx.beginPath();
      ctx.moveTo(iconX, iconY + 15);
      ctx.quadraticCurveTo(iconX + 10, iconY + 5, iconX + 20, iconY + 15);
      ctx.stroke();
    } else {
      ctx.fillRect(iconX, iconY, 20, 20);
    }

    ctx.fillStyle = '#000';
    ctx.font = '12px Arial';
    const textX = iconX + 30;
    ctx.fillText(item.text, textX, itemY + 15);
  });
};

export const renderIcon = (ctx, icon, cornerCircleDiameter) => {
  const size = icon.size || 24;
  const x = icon.x - size / 2;
  const y = icon.y - size / 2;
  
  // Draw hospital box icon
  if (icon.iconType === 'health') {
    ctx.fillStyle = icon.color || '#ffffff';
    ctx.strokeStyle = icon.color || '#000000';
    ctx.lineWidth = 2;
    
    // Draw main box
    ctx.fillRect(x, y, size, size);
    ctx.strokeRect(x, y, size, size);
    
    // Draw red cross
    ctx.fillStyle = '#ff0000';
    // Horizontal bar
    ctx.fillRect(x + size * 0.25, y + size * 0.4, size * 0.5, size * 0.2);
    // Vertical bar
    ctx.fillRect(x + size * 0.4, y + size * 0.25, size * 0.2, size * 0.5);
  }
  
  // Draw corner circle for selection
  ctx.beginPath();
  ctx.arc(icon.x, icon.y, cornerCircleDiameter, 0, 2 * Math.PI);
  ctx.fillStyle = '#ff0000';
  ctx.fill();
};

export const renderCurrentStroke = (ctx, currentStroke, controlData) => {
  if (currentStroke.length > 1) {
    ctx.beginPath();
    ctx.moveTo(currentStroke[0].x, currentStroke[0].y);
    currentStroke.forEach((point) => ctx.lineTo(point.x, point.y));
    ctx.lineWidth = controlData.lineWidth;
    ctx.lineCap = controlData.lineCap;
    ctx.strokeStyle = controlData.lineColor;
    ctx.stroke();
  }
};
